import { useMCPTT } from "../mcptt/hooks";
import { BRAND_TAGLINE, BRAND_TITLE } from "../config";

/** Transient screen between login submit and ready. */
export function Connecting({ status }: { status: string }) {
  const { signOut } = useMCPTT();
  return (
    <div className="auth-shell">
      <div className="auth-brand">
        <div className="auth-logo" aria-hidden />
        <div className="auth-title">{BRAND_TITLE}</div>
        <div className="auth-tag">{BRAND_TAGLINE}</div>
      </div>
      <div className="connect-overlay">
        <div className="progress-track">
          <div className="progress-fill" />
        </div>
        <div className="connect-status">{status}</div>
        <button type="button" className="appbar-action" onClick={signOut}>
          Cancel
        </button>
      </div>
    </div>
  );
}
